import { render, staticRenderFns } from "./ModuloTurnos.vue?vue&type=template&id=6ea188c2"
import script from "./ModuloTurnos.vue?vue&type=script&lang=js"
export * from "./ModuloTurnos.vue?vue&type=script&lang=js"
import style0 from "./ModuloTurnos.vue?vue&type=style&index=0&id=6ea188c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports